import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  marketingArea: null,
  marketingAreas: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const marketingAreaReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.MARKETINGAREA_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.MARKETINGAREA_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.MARKETINGAREA_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default marketingAreaReducer;
